import {
  TextField,
  Spinner,
  Panel,
  PanelType,
  MessageBar,
  MessageBarType,
  DefaultButton,
  PrimaryButton,
  DatePicker,
  DayOfWeek,
} from '@fluentui/react';
import React, {useEffect, useState} from 'react';
import commonStyles from '../../../common/commonStyles.module.scss';
import {getTimezoneDate} from '../../../common/dateFormatting';
import {ProductVersion} from '../../../Swagger/api';
import {getApis} from '../../../webservices';

interface IProductVersionEdit {
  onDone: () => void;
  onCancel: () => void;
  productVersion: ProductVersion;
}

export const ProductVersionEdit = (props: IProductVersionEdit) => {
  const [version, setVersion] = useState('');
  const [release, setRelease] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setVersion(props.productVersion.version || '');
    setRelease(new Date(props.productVersion.release!) || new Date());
  }, [props.productVersion.release, props.productVersion.version]);

  const onSave = async () => {
    setLoading(true);
    setHasError(false);

    const item = {
      ...props.productVersion,
      version,
      release: getTimezoneDate(release),
    };

    try {
      const {productClient} = await getApis();
      await productClient.updateProductVersion(item);
      props.onDone();
    } catch {
      setHasError(true);
      setLoading(false);
    }
  };

  return (
    <Panel
      isOpen={true}
      type={PanelType.smallFixedFar}
      onDismiss={() => props.onCancel()}
      headerText="Edit version release"
      closeButtonAriaLabel="Close"
      onRenderFooterContent={() => {
        return (
          <React.Fragment>
            <section className={commonStyles.panelButtons}>
              <PrimaryButton
                className={commonStyles.primary}
                onClick={onSave}
                disabled={loading}
              >
                Save
              </PrimaryButton>
              <DefaultButton onClick={props.onCancel}>Cancel</DefaultButton>
            </section>

            <section className={commonStyles.panelMessages}>
              {loading ? (
                <Spinner
                  label="Please wait"
                  ariaLive="assertive"
                  labelPosition="right"
                />
              ) : null}
              {hasError ? (
                <MessageBar
                  messageBarType={MessageBarType.error}
                  isMultiline={true}
                  dismissButtonAriaLabel="Close"
                >
                  Something went wrong. Please try again or contact an
                  Administrator.
                </MessageBar>
              ) : null}
            </section>
          </React.Fragment>
        );
      }}
    >
      <TextField
        label="Version name"
        value={version}
        onChange={(_event, newValue) => setVersion(newValue || '')}
      />
      <DatePicker
        label="Release date"
        firstDayOfWeek={DayOfWeek.Monday}
        placeholder="Select a date..."
        value={release}
        onSelectDate={(newValue) => setRelease(newValue || new Date())}
        ariaLabel="Select a date"
      />
    </Panel>
  );
};
